<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        
        <img class="navbar-brand-full" src="img/brand/logo.jpg" width="50" height="50" alt="PosteOne Logo">
        <img class="navbar-brand-minimized" src="img/brand/logo.jpg" width="30" height="30" alt="PosteOne Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/agences/agences-own" exact v-if="can('agence-list-own')">Mes agences</b-nav-item>
        <b-nav-item class="px-3" to="/guichets/guichets-own" v-if="can('guichet-list-own')">Mes guichets</b-nav-item>
        <b-nav-item class="px-3" to="/transferts/transferts-own" v-if="can('operation-list-own')">Mes transferts</b-nav-item>
        <b-nav-item class="px-3" to="/users/users-own" v-if="can('user-list-own')">Mes utilisateurs</b-nav-item>
        <b-nav-item class="px-3" to="/approvisionnements/approvisionnements-own" v-if="can('approvisionnement-list-own')">Mes approvisionnements</b-nav-item>
        <b-nav-item class="px-3" to="/plannings/solde" v-if="can('soldecaisse')">
            <span style="color:green"> <i class="fa fa-arrow-down"></i> {{ solde_planning.montant_total_entre }}</span> :
            <span style="color:red"><i class="fa fa-arrow-up"></i>  {{ solde_planning.montant_sorti}} </span>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!--<AsideToggler class="d-none d-lg-block" />
      <AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <Sidebar></Sidebar>
        <!-- <SidebarNav :navItems="nav"></SidebarNav> -->
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="#">PosteOne</a>
        <span class="ml-1">&copy; 2019.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="http://consultech.ci" target="_blank">Consultech SA</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import api from '../api/';
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import Sidebar from './Sidebar'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    Sidebar
  },
  data () {
    return {
      nav: nav.items,
      solde_planning :"",
      solde :"",
    }
  },
  methods:{
    can(perm){
        return this.$store.getters['auth/can'](perm)
    },
    async get_solde(){
      this.solde_planning = await api.planning.get_solde_planning().then((data)=>{
          console.log("solde tsss : ",data)
          return data.data.data[0]
      })
    },
    async get_user(){
        this.res = await store.getters['auth/get_user']
        //console.log('mon solde :',this.res.solde.toLocaleString())
        this.solde = parseInt(this.res.solde).toLocaleString("fr-FR", {style: "currency", currency: "XOF"})
        // vérification du solde pour l'affichage de la couleur
        if (parseInt(this.res.solde)>=0){
            this.green = true
        }else{
            this.green = false
        }
    
        if(this.res.role.toUpperCase() =="SUPER ADMIN"){
          this.isAdmin=true
        }
        return this.res
    }
  },
  mounted(){
    console.log('nav ',nav)
    this.get_user()
    this.get_solde()
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>
